// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"R3UwNxTr2j8mxrSkdhbh1","title":"_1BAhl6tA1XRsQoKu9ZkdeC","formControl":"_3uQgeeuGAgjHk-sFK94eRm","textArea":"_3nEX6djy7o2--3y1QYypId","label":"_3Z6FfPR9aRDCzg4yF1InQZ","buttonSection":"_5uQscGy06OSKxMyWiaXGo"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Journal/components/AddNewNote.mod.css
// module id = 1129
// module chunks = 0